module.exports = __webpack_public_path__ + "static/media/21ECLAC11.39890f4b.jpg";